import { render, staticRenderFns } from "./editpurchase.vue?vue&type=template&id=2aa39521&scoped=true&"
import script from "./editpurchase.vue?vue&type=script&lang=js&"
export * from "./editpurchase.vue?vue&type=script&lang=js&"
import style0 from "./editpurchase.vue?vue&type=style&index=0&id=2aa39521&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa39521",
  null
  
)

export default component.exports